/**
 * weekly-top-10
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules:
import weeklyTopXFactory from "./top-programmes/weekly-top-x";
import stationsSelectFactory from "./top-programmes/main-stations-select";
import moreInfoFactory from "./top-programmes/more-info";
import moreInfoViaModal from "./top-programmes/more-info-button-icon";
import weeklyPeriodSelectsFactory from "./top-programmes/weekly-period-selects";
import commonFormSend from "./vr-reports/common-form-send";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule("weekly-top-30", weeklyTopXFactory(30));
core.createModule("stationsSelect", stationsSelectFactory);
core.createModule("moreInfo", moreInfoFactory);
core.createModule("moreInfoViaModal", moreInfoViaModal);
core.createModule("periodSelects", weeklyPeriodSelectsFactory);
core.createModule("commonFormSend", commonFormSend);

core.startAll();
